import Vue from 'vue';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App.vue';
import router from './router';
import store from './store';
import axios from 'axios';
import mavonEditor from 'mavon-editor';
import 'mavon-editor/dist/css/index.css';
import 'highlight.js/styles/github.css';
import hljs from 'highlight.js';

Vue.config.productionTip = false;

// 使用ElementUI
Vue.use(ElementUI);

// 使用mavonEditor
Vue.use(mavonEditor, {
  highlightjs: hljs
});

// 配置axios
axios.defaults.baseURL = process.env.VUE_APP_BASE_API || '';
Vue.prototype.$http = axios;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app'); 